import { useCallback, useEffect, useRef, useState } from "react";
import { gameRequest } from "./gameApi";

export const useGame = (user) => {
  const [week, setWeek] = useState(null);
  const [season, setSeason] = useState(null);
  const [streak, setStreak] = useState(null);
  const [challenges, setChallenges] = useState(null);
  const [reward, setReward] = useState(null);
  const mounted = useRef(false);
  const rewardTimer = useRef(null);
  const latestReward = useRef(null);
  const id = user?.id;
  const reader = user?.role === "lezer";
  const reload = useCallback(() => {
    const load = (path, setter) => gameRequest(path).then(data => {
      if (mounted.current) setter(data);
    }).catch(() => { if (mounted.current) setter(null); });
    if (!id) return;
    load("/game/week", setWeek);
    load("/game/season", setSeason);
    if (!reader) {
      load("/me/streak", setStreak);
      load("/game/challenges", setChallenges);
    }
  }, [id, reader]);
  useEffect(() => {
    mounted.current = true;
    reload();
    const timer = setInterval(reload, 60000);
    const focus = () => { if (!document.hidden) reload(); };
    document.addEventListener("visibilitychange", focus);
    return () => {
      mounted.current = false;
      clearInterval(timer);
      clearTimeout(rewardTimer.current);
      document.removeEventListener("visibilitychange", focus);
    };
  }, [reload]);
  const afterSave = useCallback((recordingId) => {
    // Deliberately not awaited by handleSubmit. Success is already final.
    latestReward.current = recordingId;
    clearTimeout(rewardTimer.current);
    setReward(null);
    gameRequest(`/game/reward/${recordingId}`).then(data => {
      if (!mounted.current || latestReward.current !== recordingId) return;
      if (data.week) setWeek(data.week);
      if (data.streak) setStreak(data.streak);
      setReward(data.streak ? data : null);
      clearTimeout(rewardTimer.current);
      rewardTimer.current = setTimeout(() => setReward(null), 9000);
    }).catch(() => {});
    // The reward already contains fresh week/streak data; don't race it with older reads.
  }, []);
  return { week, season, streak, challenges, reward, reload, afterSave,
    showStanding: reader || (streak?.available !== false && streak?.total_memos >= 1),
    isStarter: !reader && streak?.available !== false && streak?.total_memos === 0 };
};